export { SvgInstagram } from './instagram'
export { SvgMax } from './max'
export { SvgOk } from './ok'
export { SvgRutube } from './rutube'
export { SvgTelegram } from './telegram'
export { SvgVk } from './vk'
